import { heicTo, isHeic } from 'heic-to/csp'
import { useState, useRef, } from 'react'
import useStateRef from 'react-usestateref'

const NOT_LOADED = Symbol('NOT_LOADED')
const IS_LOADING = Symbol('IS_LOADING')
const LOADED = Symbol('LOADED')
const FILE_LOADING_STATES = { NOT_LOADED, IS_LOADING, LOADED }

const useFileUpload = () => {
  // NOTE: refactor this to fileState with single object. Not counting the loading.
  const [file, setFile] = useState(null)
  const [fileType, setFileType] = useState(null)
  const [fileUrl, setFileUrlAndRef, fileUrlRef] = useStateRef(null)
 
  // Turn isFileLoaded into enumerator with states: NOT_LOADED, IS_LOADING, LOADED
  const [isFileLoaded, setIsFileLoaded] = useState(NOT_LOADED)


  // Sets already created file object url
  const setFileUrl = (url, options={}) => {
    if (!url) return;
    if (fileUrlRef.current) {
      URL.revokeObjectURL(fileUrlRef.current)
    }
    setFileUrlAndRef(url)
    // Set file type for reference
    if (options?.type) setFileType(options.type)
    return fileUrlRef.current
  }

  const handleHeic = async (file) => new Promise(async(resolve, reject) => {
    try {
      if (await isHeic(file)) {
        const jpeg = await heicTo({
          blob: file,
          type: "image/jpeg",
        })

        file = new File([jpeg], `${file.size}.jpeg`,{ type: 'image/jpeg' });
        console.log('CONVERTED HEIC TO JPEG')
        // console.log(file)
      }
      resolve(file)
    } catch (err) {
      console.error(err)
      reject(err)
    }
  })

  // takes a file-input event and extracts the file from it
  const handleFileUpload = async (e) => new Promise(async (resolve, reject) => {
    setIsFileLoaded(IS_LOADING)
    try {
      let originalFile = e.target?.files[0]
      // console.log('FILE RECIEVED:')
      // console.log(originalFile.type)

      const buffer = await originalFile.arrayBuffer();
      let file = new File([buffer], originalFile.name, { type: originalFile.type });

      // Parse file type and handle heic
      if (file?.type?.includes('image')) {
        setFileType('image')
        file = await handleHeic(file).catch((err) => { throw err })
      } else if (file?.type?.includes('video')){
        setFileType('video')
      } else {
        setFileType(null)
      }
  
      // NOTE: If we don't set the value to null, the file inputs
      //       keeps the file state set internally, and won't fire
      //       another change event if we upload the same file again
      e.target.value = null
      updateFileState(file)
      setIsFileLoaded(LOADED)
      resolve(fileUrlRef.current)
    } catch (err) {
      console.error(err)
      e.target.value = null
      resetFileState()
      setIsFileLoaded(NOT_LOADED)
      reject(err)
    }
  })

  const updateFileState = (file) => {
    const url = URL.createObjectURL(file)
    if (!url) throw `ERROR: could not create object url for file: ${file}`;
    setFile(file)
    setFileUrl(url)
  }

  const resetFileState = () => {
    URL.revokeObjectURL(fileUrlRef.current)
    setFileUrlAndRef(null)
    setIsFileLoaded(false)
    setFile(null)
  }

  return {
    file,
    fileType,
    isFileLoaded,
    setIsFileLoaded,
    handleFileUpload,
    resetFileState,
    setFileUrl,
    fileUrlRef,
    fileUrl,
  }
}

export { FILE_LOADING_STATES, NOT_LOADED, IS_LOADING, LOADED }

export default useFileUpload
